// Static product catalog mirrored on backend. Used for instant UI rendering.
export const PRODUCTS = [
  {
    id: 'collagen',
    slug: 'collagen-smoothing-mask',
    name: 'Collagen Smoothing Mask',
    tagline: 'Plump. Firm. Smooth.',
    short_description: 'A collagen-and-peptide infused sheet mask that lifts, firms and visibly minimizes fine lines for bouncy, fresh skin.',
    long_description: "Neutriherbs Collagen Mask is infused with collagen and peptides to help improve and maintain the skin's elasticity for healthier-looking skin. A plumping punch of bouncy, fresh skin: the visible smoothing, plumping and contouring effect makes fine lines and wrinkles less noticeable.",
    accent: 'blue',
    concern: 'firming',
    skin_types: ['all', 'mature', 'dry'],
    single_price: 6.0,
    pack_price: 21.0,
    pack_count: 4,
    image: 'https://customer-assets.emergentagent.com/job_8b08ef91-35e8-467a-8bae-1bf101bdaeb8/artifacts/6mw8dzb2_image.png',
    gallery: [
      'https://customer-assets.emergentagent.com/job_8b08ef91-35e8-467a-8bae-1bf101bdaeb8/artifacts/6mw8dzb2_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/qmzo7xd3_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/n029arye_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/rfa2qdd9_image.png',
    ],
    ingredients: [
      { name: 'Collagen + Peptides', benefit: 'Lifts the skin and reduces wrinkles.' },
      { name: 'Panthenol', benefit: 'Binds and holds water in the skin for deep moisture.' },
      { name: 'Camellia Flower', benefit: 'Antioxidant, anti-pollution and soothing.' },
    ],
    benefits: ['Firms & lifts', 'Smooths fine lines', 'Restores bounce'],
  },
  {
    id: 'hyaluronic',
    slug: 'hyaluronic-hydration-mask',
    name: 'Hyaluronic Acid Hydration Mask',
    tagline: 'Drench. Hydrate. Bloom.',
    short_description: '4D-Hyaluronic Acid sheet mask that targets every layer of skin for 24h moisture, elasticity and a dewy, supple finish.',
    long_description: 'Neutriherbs Hyaluronic Acid Facial Sheet Mask leverages 4D-Hyaluronic Acid—a combination of four hyaluronic acids with different molecular weights—to build a three-dimensional hydration network. Hydrates from the outside, holds water from within, and improves elasticity directly from within.',
    accent: 'green',
    concern: 'hydration',
    skin_types: ['all', 'dry', 'sensitive'],
    single_price: 6.0,
    pack_price: 21.0,
    pack_count: 4,
    image: 'https://customer-assets.emergentagent.com/job_8b08ef91-35e8-467a-8bae-1bf101bdaeb8/artifacts/4frwz2h6_Hyaluronic-acid-mask-18.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_8b08ef91-35e8-467a-8bae-1bf101bdaeb8/artifacts/4frwz2h6_Hyaluronic-acid-mask-18.jpg',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/1qa3fugf_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/vbt6u16v_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/fuc64hh0_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/f9pm6coz_image.png',
    ],
    ingredients: [
      { name: 'Ultra-High Molecular HA', benefit: 'Forms a protective film for 24h moisture and anti-pollution defense.' },
      { name: 'Sodium Hyaluronate', benefit: "Holds water on the skin's surface, nourishing the corneum." },
      { name: 'Sodium Acetylated Hyaluronate', benefit: 'Adheres firmly to the stratum corneum and repairs damage.' },
      { name: 'Hydrolyzed Sodium Hyaluronate', benefit: 'Penetrates the epidermis and dermis to hydrate from within.' },
    ],
    benefits: ['24h hydration', 'Plumps & smooths', 'Restores elasticity'],
  },
  {
    id: 'vitaminc',
    slug: 'vitamin-c-glow-mask',
    name: 'Vitamin C Glow Mask',
    tagline: 'Brighten. Glow. Renew.',
    short_description: 'A vitamin-C and yeast extract sheet mask that drenches dull skin with luminosity, hydration and an instant healthy glow.',
    long_description: 'Neutriherbs Vitamin C Brightening and Glow Sheet Mask is enriched with portulaca oleracea extract, yeast extract, citrus limon peel oil and hyaluronic acid. It deeply nourishes the skin, leaving it velvety smooth, dewy and luminous. Get a healthy, youthful glow.',
    accent: 'orange',
    concern: 'brightening',
    skin_types: ['all', 'dull', 'uneven'],
    single_price: 5.2,
    pack_price: 24.0,
    pack_count: 5,
    image: 'https://customer-assets.emergentagent.com/job_8b08ef91-35e8-467a-8bae-1bf101bdaeb8/artifacts/ww1ta922_Adobe%20Express%20-%20file%20%281%29.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_8b08ef91-35e8-467a-8bae-1bf101bdaeb8/artifacts/ww1ta922_Adobe%20Express%20-%20file%20%281%29.jpg',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/g8paxn0w_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/rjd77iv7_image.png',
      'https://customer-assets.emergentagent.com/job_sheet-mask-shop/artifacts/fofh02j2_image.png',
    ],
    ingredients: [
      { name: 'Vitamin C', benefit: "Restores radiance and corrects uneven tone." },
      { name: 'Portulaca Oleracea', benefit: 'Soothes redness, inflammation and irritation.' },
      { name: 'Yeast Extract', benefit: 'Tackles pigmentation by inhibiting melanin production.' },
      { name: 'Hyaluronic Acid', benefit: 'Increases moisture, firmness and elasticity.' },
    ],
    benefits: ['Instant glow', 'Evens tone', 'Revitalizes dull skin'],
  },
];

export const accentBg = (accent, soft = false) => {
  if (accent === 'blue') return soft ? 'accent-blue-soft' : 'accent-blue-bg';
  if (accent === 'green') return soft ? 'accent-green-soft' : 'accent-green-bg';
  return soft ? 'accent-orange-soft' : 'accent-orange-bg';
};

// Kept for backwards compat (USD). Prefer useCurrency().format(n).
export const formatPrice = (n) => `$${n.toFixed(2)}`;
